import React from 'react';
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import dayjs from "dayjs";
import DescribeYourBusinessView from './DescribeYourBusinessView';

import { CompileTOVS } from "@app/utils/CompileTOVS";
import { saveAs } from "file-saver";
import { Packer } from "docx";
import { DocumentCreator } from "@app/utils/DocumentCreator";

class ConnectedDescribeYourBusinessContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            locale: this.props.locale ? this.props.locale : 'en',
            pageLoad: '',
            // Business Description
            bizActivities: '',
            // Previous Project
            prevVoucher: '',
            previousProjectDeliverables: '',
            prevName:  '',
            prevDate:  '',
            prevAmount:  '',
            validationErrors: {
                // Business Description
                bizActivities: { show: false, check: null, errorMessage: ''  },
                // Previous Project
                previousProjectDeliverables: { show: false, check: null, errorMessage: ''  },
                // Previous Beneficiary
                prevVoucher: { show: false, check: null, errorMessage: ''  },
                prevName: { show: false, check: null, errorMessage: ''  },
                prevDate: { show: false, check: null, errorMessage: ''  },
                prevAmount: { show: false, check: null, errorMessage: ''  }
            },
            isLoading: false,
            errorMessage: '',
            successMessage: '',
            loadToSubmitTime: '',
            shareMessage: ''
        };

        // Business Description
        this.handleBizActivities = this.handleBizActivities.bind(this);
        // Previous Project
        this.handlePreviousProjectDeliverables = this.handlePreviousProjectDeliverables.bind(this);
        // Previous Beneficiary
        this.handlePrevVoucher = this.handlePrevVoucher.bind(this);
        this.handlePrevName = this.handlePrevName.bind(this);
        this.handlePrevDate = this.handlePrevDate.bind(this);
        this.handlePrevAmount = this.handlePrevAmount.bind(this);

        this.generateDoc = this.generateDoc.bind(this);
    }

    componentDidMount() {
        if (this.state.pageLoad === '') {
            this.setState({
                pageLoad: new Date().valueOf()
            });
        }
        for (var i = 0; i < localStorage.length; i++){
            if (localStorage.key(i).startsWith('tovsForm.describe.')) {
                this.setState({
                    [localStorage.key(i).substring(18)]: localStorage.getItem(localStorage.key(i))
                });
            }
        }
    }
    
    // Business Description
    handleBizActivities(e) {
        let value = e.target.value;
        let validationErrors = this.state.validationErrors;
        if (value.length === 0) {
            validationErrors.bizActivities.show = true;
            validationErrors.bizActivities.errorMessage = 'You will need to describe your business activities.';
            validationErrors.bizActivities.check = false;
        } 
        else if (value.length < 64) {
            validationErrors.bizActivities.show = true;
            validationErrors.bizActivities.errorMessage = 'You don\'t need to write a lot but be sure to cover all your business activities.';
            validationErrors.bizActivities.check = false;
            localStorage.setItem('tovsForm.describe.bizActivities', value);
        }
        else {
            validationErrors.bizActivities.show = false;
            validationErrors.bizActivities.errorMessage = '';
            validationErrors.bizActivities.check = true;
            localStorage.setItem('tovsForm.describe.bizActivities', value);
        }
        this.setState({ 
            bizActivities: value,
            validationErrors: validationErrors
        });
    }

    // Previous Project
    handlePrevVoucher(e) {
        let value = e.target.value;
        let validationErrors = this.state.validationErrors;
        if (value === 'notSure') {
            validationErrors.prevVoucher.show = true;
            validationErrors.prevVoucher.errorMessage = 'You will need to be sure before you apply!';
            validationErrors.prevVoucher.check = false;
        }
        else {
            validationErrors.prevVoucher.show = false;
            validationErrors.prevVoucher.errorMessage = '';
            validationErrors.prevVoucher.check = true;
        }
        this.setState({ 
            prevVoucher: value,
            validationErrors: validationErrors
        });
        localStorage.setItem('tovsForm.describe.prevVoucher', value);
    }
    handlePreviousProjectDeliverables(e) {
        let value = e.target.value;
        let validationErrors = this.state.validationErrors;
        if (value.length === 0) {
            validationErrors.previousProjectDeliverables.show = true;
            validationErrors.previousProjectDeliverables.errorMessage = 'You will need to describe what you did with the previous voucher.';
            validationErrors.previousProjectDeliverables.check = false;
        } 
        else if (value.length < 64) {
            validationErrors.previousProjectDeliverables.show = true;
            validationErrors.previousProjectDeliverables.errorMessage = 'You don\'t need to write a lot but be sure to describe the previous project well.';
            validationErrors.previousProjectDeliverables.check = false;
            localStorage.setItem('tovsForm.describe.previousProjectDeliverables', value);
        }
        else {
            validationErrors.previousProjectDeliverables.show = false;
            validationErrors.previousProjectDeliverables.errorMessage = '';
            validationErrors.previousProjectDeliverables.check = true;
            localStorage.setItem('tovsForm.describe.previousProjectDeliverables', value);
        }
        this.setState({ 
            previousProjectDeliverables: value,
            validationErrors: validationErrors
        });
    }

    // Previous Beneficiary
    handlePrevName(e) {
        let value = e.target.value;
        let validationErrors = this.state.validationErrors;
        let isPreviousNameValid = value !== '' && value.match(/^([A-Za-zÀ-ÖØ-öø-ÿ]{1,}([\.] |[-']| ))+[A-Za-zÀ-ÖØ-öø-ÿ]+\.?$/i) !== null;
        if (isPreviousNameValid) {
            validationErrors.prevName.check = true;
            validationErrors.prevName.errorMessage = '';
            localStorage.setItem('tovsForm.describe.prevName', value);
        }
        else {
            validationErrors.prevName.check = false;
            validationErrors.prevName.errorMessage = 'Name is invalid, at least first and last name are required';
        }
        validationErrors.prevName.show = !isPreviousNameValid;
        this.setState({
            prevName: value,
            validationErrors: validationErrors
        });
    }

    handlePrevDate(e) {
        let validationErrors = this.state.validationErrors;
        let selectedDate = dayjs(e);
        if (selectedDate.isAfter(dayjs().subtract( 9, 'month' ))) {
            validationErrors.prevDate.check = true;
            validationErrors.prevDate.errorMessage = '';
            validationErrors.prevDate.show = false;
            this.setState({ 
                prevDate: selectedDate
            });
            localStorage.setItem('tovsForm.describe.prevDate', selectedDate);
        }
        else {
            validationErrors.prevDate.check = false;
            validationErrors.prevDate.errorMessage = "You will likely need to attend a more recent webinar than one from " + selectedDate.year() + ".";
            validationErrors.prevDate.show = true;
            
        }
        this.setState({
            validationErrors: validationErrors
        });
    }

    handlePrevAmount(e) {
        let value = e.target.value;
        let validationErrors = this.state.validationErrors;
        let isPreviousAmountValid = value > 0 && value < 2501;

        if (isPreviousAmountValid) {
            validationErrors.prevAmount.check = true;
            validationErrors.prevAmount.errorMessage = '';
            localStorage.setItem('tovsForm.describe.prevAmount', value);
        }
        else {
            validationErrors.prevAmount.check = false;
            validationErrors.prevAmount.errorMessage = 'The amount does not seem right. It should be an amount no more than than €2,500';
        }
        validationErrors.prevAmount.show = !isPreviousAmountValid;
        this.setState({
            prevAmount: value,
            validationErrors: validationErrors
        });
    }

    generateDoc() {
        const data = new CompileTOVS().compile(); 
        var documentCreator = new DocumentCreator();
        var doc = documentCreator.create(data);

        Packer.toBlob(doc).then(function (blob) {
            saveAs(blob, "TradingOnlineVoucherScheme-" + Date.now() + ".docx");
        });
    }

    generateViewProps() {
        return {
            ...this.state,
            // Business Description
            handleBizActivities: this.handleBizActivities,
            // Previous Project
            handlePreviousProjectDeliverables: this.handlePreviousProjectDeliverables,
            // Previous Beneficiary
            handlePrevVoucher: this.handlePrevVoucher,
            handlePrevName: this.handlePrevName,
            handlePrevDate: this.handlePrevDate,
            handlePrevAmount: this.handlePrevAmount,
            generateDoc: this.generateDoc
        };
    }

    render() {
        const viewProps = this.generateViewProps();
        return (
            <DescribeYourBusinessView {...viewProps} />
        );
    }
}

const mapStateToProps = state => {
    return {
        locale: state.i18n.locale
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setLocale: locale => dispatch(setLocale(locale))
    };
};

const DescribeYourBusinessContainer = injectIntl(connect(mapStateToProps,mapDispatchToProps)(ConnectedDescribeYourBusinessContainer));

export default DescribeYourBusinessContainer;